import EventBus from './EventBus';
import { tagsFilterKey } from '../organisms/CatalogueFilters/helpers';
import { isAllTag } from './Tags';

let filters = null;

export const getSelectedFilters = () => {
  if (Object.keys(filters || {}).length === 0) {
    return null;
  }
  return filters;
};

export const setSelectedFilters = (updatedFiltersSelection, notify = false) => {
  filters = updatedFiltersSelection;

  if (notify) {
    EventBus.notify(EventBus.TYPE.CATALOGUE_FILTERS_CHANGED, updatedFiltersSelection);
  }
};

export const getCatalogueFiltersCounts = (selectedFilters = filters) => {
  const selectedFiltersKey = Object.keys(selectedFilters || {});
  let counts = 0;

  selectedFiltersKey.forEach(selectedKey => {
    let selections = selectedFilters[selectedKey] || [];

    if (selectedKey === tagsFilterKey) {
      // removing all tag count
      selections = selections.filter(selection => !isAllTag(selection));
    }

    counts += selections.length;
  });

  return counts;
};

EventBus.addListener(EventBus.TYPE.CLEAR_FILTER_ON_CATALOGUE_UNMOUNT, () =>
  setSelectedFilters(null)
);
